import React, { useState, forwardRef, useImperativeHandle } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.modal + 1,
        color: '#fff',
    },
}));


function SimpleBackdrop(props, ref) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const loaderMessages = [
        "Loading... ⏳",
        "Please wait... 🕰️",
        "Fetching data... 📡",
        "Preparing content... 📝",
        "Hold on tight... 🤞",
        "Almost there... 🏁",
        "Just a moment... ⏱️",
        "Loading your request... 🚀",
        "Processing... 🔄",
        "Working on it... 💪",
        "Please wait while we load information... 🕵️‍♂️",
        // "Making magic happen... 🧙‍♂️",
        // "Summoning the data spirits... 👻",
        // "Wiggling the wires... 🔌",
        // "Tickling the server... 🤖",
        // "Whistling a happy tune... 🎶",
        // "Putting on a show... 🎭",
        // "Brewing some coffee... ☕",
        // "Polishing the pixels... 🖌️",
        // "Shuffling the bits... 💻",
        // "Spinning up the hamster wheel... 🐹",
        // "Warming up the flux capacitor... ⚡",
        // "Charging the laser beams... 🔋",
        // "Summoning the Kraken... 🦑",
        // "Assembling the Avengers... 💥",
        // "Engaging warp drive... 🚀",
        // "Firing up the engines... 🔥",
        // "Initiating launch sequence... 🚀",
        // "Unleashing the fury... 🔥",
    ];

    const getRandomLoaderMessage = () => {
        const randomIndex = Math.floor(Math.random() * loaderMessages.length);
        return loaderMessages[randomIndex];
    };

    const handleClose = () => {
        setOpen(false)
    };

    useImperativeHandle(ref, () => ({
        add: () => {
            Counter.addCount();
            setOpen(true);
        },
        remove: () => {
            Counter.reduceCount();
            if (Counter.getCount() === 0)
                setOpen(false)
        }
    }))

    return (
        <Backdrop className={classes.backdrop} open={open || props.open} onClick={handleClose}>
            <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress color='inherit' />
                <Box mt={2} className='bg-dark-loader '>
                    <div className='mx-2'>{getRandomLoaderMessage()}</div>
                </Box>
            </Box>
        </Backdrop>
    )
}
//Please wait while we load information
class Counter {
    static count = 0;

    static getCount() {
        return this.count;
    }

    static addCount() {
        this.count = this.count + 1;
    }

    static reduceCount() {
        if (this.count > 0)
            this.count = this.count - 1;
    }
}

export default forwardRef(SimpleBackdrop);